import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {Session} from "../services/Session";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getProfileUsersDataUrl(org, userId) {
    return `/TaxPlanningServices/org/${org}/users/${userId}/users/list`;
}

export function getAddUserAccessDetailsUrl(org, userId, accessId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/access/${accessId}`;
}

export function getNewUserAccessDetailsUrl(org, userId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/access?user_type=internal`;
}

export function createNewUserUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/users`;
}

export function getProfileDataUrl(org, userId, id) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/users?id=${id}`;
}

export function getUserAccessDataUrl(org, userId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/userprofile`;
}

export function getUsersLimitsUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/users/limits`;
}

@Injectable({
  providedIn: 'root'
})
export class AddUserService extends  TaxplanIQServices {

  options = {};
  constructor(http: HttpClient) {
      super(http);
  }
  getPaginatedUsers(obj): Observable<any> {
      const url = this.interpolateUrl(PATH.ORGS_SERVICES, {}, {id: Session.getUser().id});
      return this.create(url + '/' + Session.getOrg() + '/preferencesList', obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  addUser(obj): Observable<any> {
    const url = createNewUserUrl(Session.getOrg(), Session.getUser().id);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateUser(obj): Observable<any> {
    const url = getProfileDataUrl(Session.getOrg(), Session.getUser().id, obj.id);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeUser(org, user, email): Observable<any> {
    const url = getProfileDataUrl(Session.getOrg(), Session.getUser().id, email);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }


  addUserAccessDetails(org, userId, accessId, pref): Observable<any> {
    const url = getAddUserAccessDetailsUrl(org, userId, accessId);
    return this.update(url, pref, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getNewUserAccessDetails(org, userId): Observable<any> {
    const url = getNewUserAccessDetailsUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCountryTypes(): Observable<any> {
      const url = this.interpolateUrl(PATH.ORGS_SERVICES, {}, {id: Session.getUser().id});
      return this.query(url + '/' + Session.getOrg() + '/countrytypes', SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUserAccessDetails(org, userId, accessId): Observable<any> {
    const url = getAddUserAccessDetailsUrl(org, userId, accessId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPaginatedProfileUsers(obj): Observable<any> {
      const url = getProfileUsersDataUrl(Session.getOrg(), Session.getUser().id);
      return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUserProfileData(orgId, id): Observable<any> {
    const url = getProfileDataUrl(orgId, Session.getUser().id, id);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUserAccessData(orgId, id): Observable<any> {
    const url = getUserAccessDataUrl(orgId, id);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUsersLimits(org, userId): Observable<any> {
    const url = getUsersLimitsUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}

